// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery {\n\t/*display: flex;*/\n\tpadding: 10px;\n}\n\n.gallery-row {\n\tdisplay: flex;\n}", ""]);
// Exports
module.exports = exports;
